import React from 'react'
import './Toggle.css';

function Toggle({style, icon, enabled, onToggle}) {
    let className = "ToggleButton";
    if (enabled) className += " ToggleEnabled ";
    if (!enabled) className += " ToggleDisabled ";
    className += style;

    return <button className={className} onClick={onToggle}>
        {icon}
    </button>
}

export default Toggle;
